/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProtectedGroupDataset } from './ProtectedGroupDataset';
import {
  ProtectedGroupDatasetFromJSON,
  ProtectedGroupDatasetFromJSONTyped,
  ProtectedGroupDatasetToJSON,
} from './ProtectedGroupDataset';

/**
 *
 * @export
 * @interface PaginatedProtectedGroupDatasetList
 */
export interface PaginatedProtectedGroupDatasetList {
  /**
   *
   * @type {number}
   * @memberof PaginatedProtectedGroupDatasetList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedProtectedGroupDatasetList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedProtectedGroupDatasetList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ProtectedGroupDataset>}
   * @memberof PaginatedProtectedGroupDatasetList
   */
  results: Array<ProtectedGroupDataset>;
}

/**
 * Check if a given object implements the PaginatedProtectedGroupDatasetList interface.
 */
export function instanceOfPaginatedProtectedGroupDatasetList(
  value: object,
): value is PaginatedProtectedGroupDatasetList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedProtectedGroupDatasetListFromJSON(json: any): PaginatedProtectedGroupDatasetList {
  return PaginatedProtectedGroupDatasetListFromJSONTyped(json, false);
}

export function PaginatedProtectedGroupDatasetListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedProtectedGroupDatasetList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ProtectedGroupDatasetFromJSON),
  };
}

export function PaginatedProtectedGroupDatasetListToJSON(value?: PaginatedProtectedGroupDatasetList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ProtectedGroupDatasetToJSON),
  };
}
